import type { UserAccountPortfolio, UserProject } from '@repo/services'
import { ValueWithUnit } from '@repo/shared/components'
import { Link } from '@repo/shared/i18n/navigation'
import { globalConfig } from '@repo/shared/utils'
import { AspectRatio, Col, Row, Typography } from '@repo/ui/components'
import Image from 'next/image'

export const WalletProjectCardItem = ({
  project,
  userProject,
}: {
  project: UserProject
  userProject: UserAccountPortfolio
}) => {
  const url = project?.logoURL
    ? `${globalConfig.baseImageUrl}${project?.logoURL}`
    : '/images/placeholder.webp'
  return (
    <Link
      href={
        project.kind === 'crypto'
          ? `/history/balance/crypto/${project.token}`
          : `/history/balance/project/${project.token}`
      }
      className='border-b border-neutral-surface-5  last:border-none py-md'
      prefetch='auto'
    >
      <Row className='gap-md'>
        <div className='w-3xl'>
          <AspectRatio className='aspect-1/1'>
            <Image
              src={url}
              alt='Photo of property'
              fill
              sizes='(max-width: 768px) 100vw, 32px'
              className='h-full w-full  rounded-2xs object-cover'
              loading='lazy'
            />
          </AspectRatio>
        </div>

        <div className='gap-xs flex  items-end justify-between w-full flex-row'>
          <Col className='gap-xs'>
            {project.displayName && (
              <Typography
                size='xs'
                weight='bold'
                color='text-neutral-surface-100'
              >
                {project.displayName}
              </Typography>
            )}
            <Row className='gap-xs'>
              <Typography size='2xs' color='text-neutral-surface-60'>
                {project.token}
              </Typography>
            </Row>
          </Col>

          <Col className='justify-end gap-md items-end'>
            {/* wallet: projects and crypto */}
            <ValueWithUnit
              value={userProject.availableBalance || 0}
              unit={project.kind}
              scale={project.scale}
            />
            <Row className='gap-2xs w-fit'>
              <ValueWithUnit
                value={userProject.estimatedAvailableBalance || 0}
                unit='TMN'
                valueWeight='regular'
                valueSize='xs'
                scale={10}
              />
            </Row>
          </Col>
        </div>
        {/* <Icon name='ChevronLeft' size='xs' color='fill-neutral-surface-20' /> */}
      </Row>
    </Link>
  )
}
